import { create } from "zustand";
import { initialState, TCompanyStore } from "./company.state";
import { createCompanyActions } from "./company.actions";

/**
 * State management store of the V3 search - Full Documents company selection
 * @example
 * ```
 * const companies = useCompanyStore((state) => state.companies)
 * const dispatch = useCompanyStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_COMPANY_ITEMS, payload: companies })
 * ```
 */
export const useCompanyStore = create<TCompanyStore>((set, get) => ({
    ...initialState,
    ...createCompanyActions(set, get),
}));
